export const FILTER_KEY_TYPES = 'typeIds';
export const FILTER_KEY_STATUSES = 'statuses';
export const FILTER_KEY_TIME_CATEGORY = 'timeCategory';
export const FILTER_KEY_DATE_RANGE = 'dateRange';
export const FILTER_KEY_REQUESTER_IDS = 'requesterIds';

export const TIME_OFFS_TABLE_FILTER_KEYS = [
  FILTER_KEY_TYPES,
  FILTER_KEY_STATUSES,
  FILTER_KEY_TIME_CATEGORY,
  FILTER_KEY_DATE_RANGE,
  FILTER_KEY_REQUESTER_IDS,
];

export const TIME_OFFS_TABLE_FILTERS_STORAGE_KEY = 'time-offs-table-filters';

export const TIME_OFFS_TABLE_ID = 'time-offs-list';
